class QbTransactionModalController {
  constructor($scope, $uibModalInstance) {
    'ngInject';

    $scope.transactionId = $uibModalInstance.transactionId;

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }
}

export default QbTransactionModalController;



// WEBPACK FOOTER //
// ./client/common/modals/QbTransactionModal/qbTransactionModal.controller.js